import { axiosDS } from '@pp/axios'
import { AddressParamsModel } from 'Models'
import { urls } from 'Src/constants/Urls'
import { AddressModel } from 'Pages/advertisement/models'

export const addressApi = {
	getAddress: async (params?: AddressParamsModel) => {
		const res = await axiosDS().get<AddressModel[]>(urls.dadata.fias, { params })
		return res.data
	},
}
